/* Silent footage: load near the section, play in view, respect reduced motion. */
(function () {
  'use strict';
  document.querySelectorAll('[data-cg-film]').forEach(function (film) {
    if (film.dataset.ready) return;
    film.dataset.ready = 'true';
    const video = film.querySelector('[data-cg-film-video]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = navigator.connection && navigator.connection.saveData;
    let inView = false;
    video.defaultMuted = true;
    video.muted = true;
    video.volume = 0;
    function load() {
      if (!video.getAttribute('src')) {
        video.src = video.dataset.src;
        video.load();
      }
    }
    function sync() {
      if (inView && !document.hidden && !reducedMotion.matches && !saveData) {
        load();
        video.muted = true;
        const request = video.play();
        if (request) request.catch(function () { /* Keep the poster if autoplay is unavailable. */ });
      } else video.pause();
    }
    if ('IntersectionObserver' in window) {
      const loader = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          if (!reducedMotion.matches && !saveData) load();
          loader.disconnect();
        }
      }, { rootMargin: '200px' });
      loader.observe(film);
      const playback = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.15 });
      playback.observe(video);
    }
    document.addEventListener('visibilitychange', sync);
    reducedMotion.addEventListener('change', sync);
  });
})();
